import { NavLink } from "react-router-dom";
import IconButton from "/src/components/UI/Button/IconButton/IconButton";
import "./TitleContainer.css";

function TitleContainer({title, url}) {
    
    return (
        <div className="title-container">
            <span className="title">{title}</span>
            {url ?
                <NavLink to={url}>
                    <IconButton className="main-iconButton profil_action main_add-button space_tableButton" icon="fas fa-plus"/>
                </NavLink> : null
            }
        </div>
    )
}

export default TitleContainer;